import { type UserFormValues } from '@/api/types';

// Backend DTO structure for UserCreateRequest
export interface UserCreateRequest {
  username: string;
  password: string;
  firstName: string;
  lastName: string;
  email: string;
  enabled: boolean;
  roles: string[];
  phone?: string;
}

// Backend DTO structure for UserUpdateRequest (all fields optional)
export interface UserUpdateRequest {
  username?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  enabled?: boolean;
  roles?: string[];
  phone?: string;
}

/**
 * Transform UserFormValues to backend UserCreateRequest DTO format
 * - Converts state (number 0/1) to enabled (boolean)
 * - Uses roles array directly (already in correct format)
 * - Removes confirmPassword field
 */
export function normalizeCreateUserRequest(values: UserFormValues): UserCreateRequest {
  const { confirmPassword, state, ...rest } = values;

  return {
    username: rest.username,
    password: rest.password!,
    firstName: rest.firstName,
    lastName: rest.lastName,
    email: rest.email!,
    enabled: state === 1,
    roles: rest.roles || [],
    phone: rest.phone,
  };
}

/**
 * Transform UserFormValues to backend UserUpdateRequest DTO format
 * - Converts state (number 0/1) to enabled (boolean)
 * - Uses roles array directly (already in correct format)
 * - Removes confirmPassword and password fields (backend doesn't support password in update)
 */
export function normalizeUpdateUserRequest(values: UserFormValues): UserUpdateRequest {
  const { confirmPassword, state, password, ...rest } = values;

  const updateRequest: UserUpdateRequest = {
    username: rest.username,
    firstName: rest.firstName,
    lastName: rest.lastName,
    email: rest.email || undefined,
    enabled: state === 1,
    roles: rest.roles || [],
    phone: rest.phone,
  };

  return updateRequest;
}
